import script from "./LoaderSpiner.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderSpiner.vue?vue&type=script&setup=true&lang=js"

import "./LoaderSpiner.vue?vue&type=style&index=0&id=81facd68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81facd68"]])

export default __exports__